<template>
  <div>
    {{ $t('message.value', { value: 'This is an example of content translation' }) }}
  </div>
</template>
<script>
export default {
  name: 'Multilingual'
}
</script>